<template>
  <div class="px-3 pt-3 sm:px-8 sm:pt-8">
    <div
      class="sm:my-6 p-4 sm:p-6 rounded mx-auto max-w-2xl"
      :style="config.form.styles"
    >

      <div v-html="config.form.content" />

      <div
        v-if="isFullCapacity || noMoreTicketsAvailable"
        class="flex items-center rounded bg-warning-60 max-w-sm mx-auto text-white text-sm font-bold px-4 py-3 mb-8"
        role="alert"
      >
        <svg
          class="fill-current w-20 h-20 mr-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
        <p>{{ fullCapacityMessage }}</p>
      </div>

      <div
        v-if="!ticketTypes.length"
        class="flex items-center rounded bg-warning-60 max-w-sm mx-auto text-white text-sm font-bold px-4 py-3 mb-8"
        role="alert"
      >
        <svg
          class="fill-current w-20 h-20 mr-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
        <p>{{ noMoreTicketsMessage }}</p>
      </div>

      <div
        class="mx-auto"
        :style="config.form.formFields.styles"
      >
        <div
          v-for="(field, index) in formFieldPararams"
          :key="field.type + '_' + index"
          class="my-2"
        >
          <template v-if="field.web && isVisible(field)">
            <template v-if="field.type === 'ticketType' && shouldShowCalendarInput === true">
              <TicketTypeCalendarInput
                :ticketTypes="ticketTypes"
                :ticketTypesWithPrices="ticketTypesWithPrices"
                @ticketTypeFullCapacity="onTicketTypeSelected"
                @loadingTicketType="onLoadingTicketTypeSelected"
                :eventWithPayment="ticketPayment.enabled"
                :eventId="eventId"
                :parameters="field"
                v-model="fields[field.type]"
                :errorStyle="config.form.formFields.errors.styles"
                :labelStyle="config.form.formFields.labels.styles"
              />
            </template>
            <template v-else>
              <component
                v-if="field.type === 'custom'"
                :is="field.component"
                v-model="fields['customFields'][field.config.id]"
                :parameters="field"
                :errorStyle="config.form.formFields.errors.styles"
                :labelStyle="config.form.formFields.labels.styles"
              />

              <component
                v-else
                :is="field.component"
                v-model="fields[field.type]"
                @loadingTicketType="onLoadingTicketTypeSelected"
                @ticketTypeFullCapacity="onTicketTypeSelected"
                :ticketTypes="field.type=='ticketType' ? ticketTypesWithPrices : null"
                :eventId="eventId"
                :parameters="field"
                :errorStyle="config.form.formFields.errors.styles"
                :labelStyle="config.form.formFields.labels.styles"
              />
            </template>
          </template>
        </div>

        <div
          v-for="(htmlField, index) in richTextFields"
          :key="'html_' + index"
          class="my-2"
          v-html="htmlField.html"
        />

        <div v-if="isTicketTypeWithPayment">
          <XStripePaymentInput
            label="Pago con tarjeta"
            :errorStyle="config.form.formFields.errors.styles"
            :labelStyle="config.form.formFields.labels.styles"
            :stripeKey="ticketPayment.stripeKey"
            :buyerFullName="attendeeFullName"
            :buyerEmail="fields['email']"
            :priceTicket="priceTicket"
            :eventId="eventId"
            ref="payment"
          />
        </div>

        <XButton
          class="mt-3"
          :size="config.form.formFields.submit.size"
          :style="config.form.formFields.submit.styles"
          :loading="loading"
          :disabled="hasTicketTypeInput ? !ticketTypes.length : false"
          @click="onSubmit"
        >
          {{ isTicketTypeWithPayment ? $t('common.pay') : config.form.formFields.submit.content }}
        </XButton>

        <!-- <XButton @click="onPay">Probar pago</XButton> -->

        <div
          v-if="errorMessage"
          class="mt-3 mx-auto"
          :style="config.form.formFields.styles"
        >
          <XMessageBox
            type="error"
            :message="errorMessage"
            :customStyles="config.form.formFields.errors.styles"
          />
        </div>

        <div
          v-for="(htmlField, index) in richTextFieldsBellow"
          :key="'html_bellow_' + index"
          class="mt-3"
          v-html="htmlField.html"
        />
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import _ from 'lodash'
import { sendHitTrack } from '@plat/util/analytics'

import XTextInput from '@plat/views/partials/fields/TextInput'
import XTextareaInput from '@plat/views/partials/fields/TextareaInput'
import XNumberInput from '@plat/views/partials/fields/NumberInput'
import XEmailInput from '@plat/views/partials/fields/EmailInput'
import XBirthYearInput from '@plat/views/partials/fields/BirthYearInput'
import XTitleInput from '@plat/views/partials/fields/TitleInput'
import XGenderInput from '@plat/views/partials/fields/GenderInput'
import XBirthDateInput from '@plat/views/partials/fields/BirthDateInput'
import XSelectInput from '@plat/views/partials/fields/SelectInput'
import XTicketTypeInput from '@plat/views/partials/fields/TicketTypeInput'
import XSelectMultipleInput from '@plat/views/partials/fields/SelectMultipleInput'
import XCheckboxInput from '@plat/views/partials/fields/CheckboxInput'
import XDateInput from '@plat/views/partials/fields/DateInput'
import XAgreementInput from '@plat/views/partials/fields/AgreementInput'
import XCountryInput from '@plat/views/partials/fields/CountryInput'
import XEmojiReactionInput from '@plat/views/partials/fields/EmojiReactionInput'
import XInterestsInput from '@plat/views/partials/fields/InterestsInput'
import XStripePaymentInput from '@plat/views/partials/fields/StripePaymentInput'
import TicketTypeCalendarInput from '@plat/views/partials/fields/TicketTypeCalendarInput'

import FormBaseValidator from '@common/mixins/FormBaseValidator'

export default {
  mixins: [FormBaseValidator],

  provide () {
    return {
      '$validator': this.$validator
    }
  },

  components: {
    XTextInput,
    XTextareaInput,
    XNumberInput,
    XEmailInput,
    XBirthYearInput,
    XTitleInput,
    XGenderInput,
    XBirthDateInput,
    XSelectInput,
    XSelectMultipleInput,
    XDateInput,
    XCheckboxInput,
    XAgreementInput,
    XCountryInput,
    XEmojiReactionInput,
    XInterestsInput,
    XStripePaymentInput,
    XTicketTypeInput,
    TicketTypeCalendarInput
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    eventSlug: {
      type: String,
      required: true
    },
    eventAccountId: {
      type: String,
      required: true
    },
    formFields: {
      type: Array,
      required: true
    },
    ticketTypes: {
      type: Array,
      required: true
    },
    ticketPayment: {
      type: Object,
      required: false
    },
    token: {
      type: String,
      required: false
    },
    redirectToTimeline: {
      type: Boolean
    },
    lang: {
      type: Object,
      required: false
    },
    ticketWithFormattedDate: {
      type: Boolean
    }
  },

  data () {
    return {
      fields: {
        customFields: {}
      },
      loading: false,
      typeTextList: [
        'firstName',
        'lastName',
        'secondLastName',
        'phone',
        'postalCode'
      ],
      errorMessage: null,
      locale: {
        es: 'Español',
        en: 'Ingles'
      },
      createAttendeeResult: null,
      isTicketTypeFullCapacity: false,
      noMoreTicketsAvailable: false
    }
  },

  created () {},

  watch: {
    formFields: {
      immediate: true,
      handler: function (newFields) {
        newFields.forEach(field => {
          if (!field.hasOwnProperty('web') || field.web) {
            this.initFormFields(field)
          }
        })
      }
    }
  },

  computed: {
    formFieldPararams () {
      return this.formFields
        .filter(field => (field.config && field.config.type !== 'rich_text'))
        .map(field => {
          let config = _.clone(field.config)

          if (this.lang && field.type === 'custom') {
            config.label = this.lang[field.config.label] || field.config.label
          }

          return {
            config,
            type: field.type,
            required: field.required,
            web: field.hasOwnProperty('web') ? field.web : true,
            component: this.typeTextList.includes(field.type)
              ? 'XTextInput'
              : field.type !== 'custom'
                ? 'X' + _.upperFirst(_.camelCase(field.type)) + 'Input'
                : 'X' + _.upperFirst(_.camelCase(field.config.type)) + 'Input'
          }
        })
    },

    richTextFields () {
      let htmlField = this.formFields
        .filter(
          field => field.type === 'custom' &&
                   field.config.type === 'rich_text' &&
                   !field.config.options.bellowSubmit
        )
        .map(field => ({ html: field.config.options.html }))

      return htmlField.length > 0 ? htmlField : null
    },

    richTextFieldsBellow () {
      let htmlField = this.formFields
        .filter(
          field => field.type === 'custom' &&
                   field.config.type === 'rich_text' &&
                   field.config.options.bellowSubmit
        )
        .map(field => ({ html: field.config.options.html }))

      return htmlField.length > 0 ? htmlField : null
    },

    isPaidEvent () {
      return this.ticketPayment.enabled && this.priceTicket > 0
    },

    isFullCapacity () {
      return this.$route.name === 'registrationFormFullCapacity'
    },

    fullCapacityMessage () {
      return this.$t('common.notifications.messages.fullCapacity')
    },

    noMoreTicketsMessage () {
      return this.$t('common.notifications.messages.noMoreTickets')
    },

    hasTicketTypeInput () {
      let hasTicketInput = false
      hasTicketInput = this.formFields.some(function (field) {
        return (field.type === 'ticketType')
      })

      return hasTicketInput
    },

    ticketTypesWithPrices () {
      if (this.ticketPayment.enabled) {
        return this.ticketTypes.map(field => {
          return {
            ticket: field.ticket,
            label: field.label + ' - ' + this.currencyFormatEUR(Number(field.price)),
            price: field.price
          }
        })
      }

      return this.ticketTypes
    },

    attendeeFullName () {
      return [
        this.fields['firstName'],
        this.fields['lastName'],
        this.fields['secondLastName']
      ]
        .filter(value => value !== undefined)
        .join(' ')
    },

    priceTicket () {
      if (this.ticketPayment.enabled && this.hasTicketTypeInput) {
        return this.fields['ticketType'] ? this.fields['ticketType']['price'] : 0
      }

      return 0
    },

    isTicketTypeWithPayment () {
      if (this.isPaidEvent && this.priceTicket > 0 && this.fields['email'] !== '' && this.attendeeFullName !== '' && this.isTicketTypeFullCapacity === false) {
        return true
      }

      // for tests
      // if (this.isPaidEvent && this.priceTicket > 0) {
      //   return true
      // }

      return false
    },
    shouldShowCalendarInput () {
      let mostrar = true
      // Mostrar calendario solo para las cuentas: CASA SEAT y CUPRA CITY GARAGE
      if (this.eventAccountId !== '106' && this.eventAccountId !== '1232') {
        mostrar = false
      }

      if (this.ticketWithFormattedDate === false) {
        mostrar = false
      }
      return mostrar
    }
  },

  mounted () {
    const locale = this.$i18n.locale.split('_').shift()
    this.$validator.localize(locale)
  },

  methods: {
    isVisible (field) {
      let conditions = _.get(field, 'config.rules.visibleIf', null)

      if (conditions === null) {
        return true
      }

      conditions = conditions
        .filter(condition => {
          // Return opposite to reduce array when the condition pass
          switch (condition.operator) {
            case '=':
              if (this.fields.customFields[condition.field]) {
                return this.fields.customFields[condition.field] !== condition.value
              }

              if (this.fields[_.camelCase(condition.field)]) {
                return this.fields[_.camelCase(condition.field)] !== condition.value
              }

              return true
            case '!=':
              if (this.fields.customFields[condition.field]) {
                return this.fields.customFields[condition.field] === condition.value
              }

              if (this.fields[_.camelCase(condition.field)]) {
                return this.fields[_.camelCase(condition.field)] === condition.value
              }

              return true
            default:
              return false
          }
        })

      return conditions.length === 0
    },

    async onSubmit () {
      if (this.loading) {
        return
      }

      this.loading = true
      this.errorMessage = null

      if (this.lang) {
        this.fields.customFields['lang#123'] = window.location.search
          ? this.locale[window.location.search.split('?')[1]]
          : this.locale['es']
      }

      // Validation
      if (await this.validate() === false) {
        this.loading = false
        return
      }

      // Cuando se selecciona un día que no tiene ticketType
      // Check if ticketType field exists and if the selected ticket type exists in ticketTypes
      if (this.fields['ticketType'] && !this.ticketTypes.some(type => type.ticket === this.fields['ticketType']['ticket'])) {
        this.errorMessage = this.$t('common.notifications.messages.invalidTicketType')
        this.loading = false
        return
      }

      // Check si aún quedan plazas para el ticket type antes de crear el asistente
      if (this.isTicketTypeWithPayment) {
        try {
          await this.validateAvailableTickets()
        } catch (errors) {
          let graphQLError = errors.graphQLErrors ? errors.graphQLErrors[0] : null
          this.errorMessage = graphQLError && this.getGraphQlValidationError(graphQLError)
            ? this.getGraphQlValidationError(graphQLError)
            : this.$t('common.notifications.messages.requestError')

          this.loading = false
          return
        }

        // Si no hay más plazas disponibles
        // se muestra el mensaje y paramos el proceso
        if (this.noMoreTicketsAvailable) {
          this.isTicketTypeFullCapacity = true
          this.loading = false
          return
        } else {
          // Procemos con el pago
          // Card validation && Payment validation
          const paymentField = this.$refs['payment']
          if (paymentField !== undefined) {
            paymentField.error = null
            if (this.isPaidEvent && paymentField.isCardCompleted === false) {
              this.loading = false
              return
            } else {
              if (await paymentField.pay() === true) {
                this.fields['paymentIntentId'] = paymentField.paymentIntentId
              } else {
                this.loading = false
                return
              }
            }
          }
        }
      }

      // Create attendee
      try {
        await this.createAttendee()
      } catch (errors) {
        let graphQLError = errors.graphQLErrors ? errors.graphQLErrors[0] : null
        this.errorMessage = graphQLError && this.getGraphQlValidationError(graphQLError)
          ? this.getGraphQlValidationError(graphQLError)
          : this.$t('common.notifications.messages.requestError')

        this.loading = false
        return
      }

      // Analytics hit
      try {
        sendHitTrack({ category: 'attendee', event: 'registered' })
      } catch (error) {}

      // Redirect
      const attendeeId = this.createAttendeeResult.id

      if (this.redirectToTimeline) {
        location.href = '/' + this.eventSlug + '/timeline/' + attendeeId
      } else {
        this.$emit('attendeeCreated', attendeeId)

        if (this.createAttendeeResult.status === 'interested') {
          this.$router.push({
            path: '/waitinglist'
          })
        } else {
          this.$router.push({
            path: '/attendee/' + attendeeId + '/success'
          })
        }
      }

      this.loading = false
    },

    // just for tests
    async onPay () {
      if (this.isPaidEvent) {
        const paymentField = this.$refs['payment']
        if (paymentField !== undefined) {
          await paymentField.pay()
        }
      }
    },

    validateAvailableTickets () {
      return this.$apollo
        .query({
          query: gql`query Event ($eventId: Uuid!, $ticketType: String) {
            event (eventId: $eventId) {
              isRegistrationFullCapacity (ticketType: $ticketType)
            }
          }`,
          fetchPolicy: 'network-only',
          variables: {
            eventId: this.eventId,
            ticketType: this.fields['ticketType']['ticket']
          }
        })
        .then(result => {
          this.noMoreTicketsAvailable = result.data.event.isRegistrationFullCapacity
        })
    },

    createAttendee () {
      if (this.createAttendeeResult !== null) {
        return Promise.resolve()
      }

      return this.$apollo
        .mutate({
          mutation: gql`
            mutation createAttendee($eventId: Uuid!, $input: CreateAttendeeInput!, $token: String) {
              event (eventId: $eventId) {
                createAttendee(input: $input, token: $token) {
                  id
                  status
                }
              }
            }
          `,
          variables: {
            eventId: this.eventId,
            input: {
              ...this.fields
            },
            token: this.token
          }
        })
        .then(result => {
          this.createAttendeeResult = result.data.event.createAttendee
        })
    },

    getGraphQlValidationError (graphQLError) {
      if (graphQLError.extensions.category === 'validationNotPassed') {
        let validationKeys = Object.keys(graphQLError.validation)
        let validationMessage = graphQLError.validation[validationKeys[0]][0]

        return graphQLError.message + ': ' + validationMessage
      }

      return null
    },

    initFormFields (field) {
      if (field.type === 'custom') {
        if (field.config.type === 'checkbox') {
          this.$set(this.fields.customFields, field.config.id, false)

          return
        }

        if (field.config.type === 'agreement') {
          this.$set(this.fields.customFields, field.config.id, null)

          return
        }

        this.$set(this.fields.customFields, field.config.id, '')

        return
      }

      this.$set(this.fields, field.type, '')
    },

    onLoadingTicketTypeSelected (loading) {
      this.loading = loading
      this.errorMessage = ''
    },

    onTicketTypeSelected (isTicketTypeFullCapacity) {
      this.isTicketTypeFullCapacity = isTicketTypeFullCapacity
    },

    currencyFormatEUR (num) {
      return (
        num
          .toFixed(2) // always two decimal digits
          .replace('.', ',') // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
      ) // use . as a separator
    }
  }
}
</script>
